module.exports = __webpack_public_path__ + "static/icons/icon-map--uk-eba05e93860d563dcca514404106d432.svg";